module.exports = __webpack_public_path__ + "static/img/fxng.4a75c11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fxng.png
// module id = LbqC
// module chunks = 4